<template>
    <div>
      <p><i class="icon iconfont el-icon-b2carrowleft" style="cursor: pointer" @click="backBtn" ></i>  <span>企业名称：{{company}}</span></p>
      <div class="seachList"><span class="name">时间：</span>
        <a-range-picker class="seachs" v-model="search.submit_time" @change="getList(1)"  :allowClear="true" :showTime="false"  format="YYYY-MM-DD"/>
      </div>
        <div class="flex-left" style="margin-top: 10px">
            <p><span>金额：{{total_money}}美元</span></p>
             </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"   >
        </a-table>

    </div>
</template>

<script>
    import API from "./api";
    import moment from "moment"
    import {ArrowLeftOutlined} from '@ant-design/icons-vue';
    const columns = [
        {
            title:"订单编号",
            dataIndex: "order_no",
            key: "order_no",
        },
         {
             title: "商品金额",
             dataIndex: "goods_value",
             ellipsis: true,
             key: "goods_value",
         },
         {
             title: "商品金额（美元）",
             dataIndex: "goods_value_dollar",
             ellipsis: true,
             key: "goods_value_dollar",
         }, {
        title: "报送时间",
        dataIndex: "submit_time_text",
        ellipsis: true,
        key: "submit_time_text",
      },
    ];
    export default {
        name: "index",
      components: {ArrowLeftOutlined},
        data() {
            return {
              company:'',
              total_money:'',
                id: this.$route.query.id,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
              search:{submit_time:[],type:2 },
                columns,
                loading: true,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/AOrderStatisticsSJZ"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList(1)
        },
        methods: {
            backBtn(){
                this.$router.push({path: '/DataStatistics/AOrderStatisticsSJZ'})
            },
            getList(page) {
              if (this.search.submit_time.length > 0) {
                this.search.submit_time[0] = moment(this.search.submit_time[0]).format('YYYY-MM-DD')
                this.search.submit_time[1] = moment(this.search.submit_time[1]).format('YYYY-MM-DD')
              }
              API.service.GET_DETAIL_LIST({page: page || 1,a_customer_id:this.id,...this.search}).then(res => {
                    let data=res.data.data.list.data
                    this.company=res.data.data.company
                    this.total_money=res.data.data.total_money
                    data.map((item,index)=>{
                        item.id=index
                    })
                    this.data = data
                    this.pagination.total = res.data.data.list.total
                    this.pagination.pageSize = res.data.data.list.per_page
                    this.pagination.current = res.data.data.list.current_page
                    this.loading = false
                })
            },

        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
    .flex-left{display: flex;}
    >>>.ant-table-row-cell-break-word{white-space:nowrap;}
</style>
